import { render, staticRenderFns } from "./new_payment_event_for_card.vue?vue&type=template&id=70008a85&scoped=true&"
import script from "./new_payment_event_for_card.vue?vue&type=script&lang=js&"
export * from "./new_payment_event_for_card.vue?vue&type=script&lang=js&"
import style0 from "./new_payment_event_for_card.vue?vue&type=style&index=0&id=70008a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70008a85",
  null
  
)

export default component.exports